import gql from 'graphql-tag';

export const createContactList = gql`
  mutation createContactList($input: CreateContactListInput) {
    createContactList(input: $input) {
      id
      MemberCodes {
        id
        code
      }
      name
      ContactListUpdaters {
        id
        ContactId
      }
      BusinessUnits {
        id
        name
      }
      ContactListMembers {
        id
        ContactId
        order
        isScheduled
        Contact {
          id
          firstName
          lastName
          nickName
          inactiveAdAccount
          afterHoursPhoneNumber
          speedDial
          version
          Company {
            id
            name
            abbreviation
            version
          }
          adAccountName
          JobRole {
            id
            name
            version
          }
          ReportsTo {
            id
            firstName
            lastName
            ReportsTo {
              id
              firstName
              lastName
              ReportsTo {
                id
                firstName
                lastName
              }
            }
            version
          }
          businessMobile
          businessPhone
          home
          other
          personalMobile
          adAccountName
          city
          Availabilities {
            id
            ContactId
            start
            end
            version
          }
        }
      }
      Facilities {
        id
        Locations {
          id
          state
          county
          township
        }
      }
      AdditionalResourceListType {
        id
        name
        enabled
      }
    }
  }
`;
